import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

export type InputModalParams = {
  icon: string;
  level: ModalLevel;
  page: ModalPage;
  text?: string;
  title: string;
  confirmText: string;
  themeColor: string;
}

type ModalLevel = 'normal' | 'warning' | 'danger';

type ModalPage = 'readings' | 'charts' | 'alerts' | 'reports';

@Component({
    selector: 'app-input-dialog-modal',
    templateUrl: './input-dialog-modal.component.html',
    styleUrls: ['./input-dialog-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputDialogModalComponent {

  @Input()
  title: string;

  @Input()
  text: string;

  @Input()
  confirmText: string;

  @Input()
  icon: string;

  @Input() themeColor: string;

  @Input()
  level: ModalLevel;

  @Input()
  page: ModalPage;

  label = ''

  constructor (public modal: NgbActiveModal) {
  }

  save (): void {
    if(this.label === '') {
      return
    }
    this.modal.close(this.label)
  }
}
